export enum ScheduleView {
  LIST = "list",
  CALENDAR = "calendar",
  DISPATCH = "dispatch",
}
